/* eslint-disable no-console */
const JSLogger = require("js-logger");
const Sentry = require("@sentry/browser");
const SENTRY_IGNORE_ERRORS = require("../../web/config/sentry.js");

// eslint-disable-next-line react-hooks/rules-of-hooks
JSLogger.useDefaults();

const debug = (...logs) => {
  JSLogger.debug(logs.join());
};

const log = (...logs) => {
  JSLogger.debug(logs.join());
};

const info = (...logs) => {
  if (typeof window === "undefined") {
    const logEntry = {
      level: "info",
      timestamp: new Date().toISOString(),
      message: logs.join(),
    };

    const output = JSON.stringify(logEntry);

    // @ts-ignore
    return process.stdout.write(`${output}\n`);
  }

  JSLogger.info(logs.join());
};

const warn = (...logs) => {
  JSLogger.warn(logs.join());
};

const error = (...logs) => {
  if (logs?.length > 0) {
    const errorMessage = logs[0]?.message || logs[0];
    const isIgnored = SENTRY_IGNORE_ERRORS.some((pattern) =>
      new RegExp(pattern).test(errorMessage)
    );

    if (isIgnored) {
      console.error(errorMessage);
      return;
    }
  }
  const additionalInfo = {
    url:
      typeof window !== "undefined" && window.location
        ? window.location.href
        : undefined,
    cookies: typeof document !== "undefined" ? document.cookie : undefined,
    onServer: typeof window === "undefined",
  };

  const msg = Array.isArray(logs)
    ? [logs, additionalInfo].map((oneLog) => JSON.stringify(oneLog)).join()
    : JSON.stringify(logs);

  Sentry.withScope((scope) => {
    scope.setExtra("content", msg);
    Sentry.captureException(new Error(`Custom error: ${msg}`));
  });

  JSLogger.error(msg, ...logs, additionalInfo);
};

module.exports = {
  debug,
  log,
  info,
  warn,
  error,
};
